import $ from 'jquery';
const MODULE_NAME = 'nettoMaradvanyertekValidator';
export default angular.module(MODULE_NAME, []).directive('nettoMaradvanyertekValidator', function () {
	'ngInject';
	return {
		restrict: 'A',
		require: ['^form', 'ngModel'],
		link: function (scope, element, attrs, ctrls) {

			var formCtrl = null;
			var modelCtrl = null;

			for (var name in ctrls) {
				if (ctrls[name].$name == '$ctrl.kalkulatorForm') {
					formCtrl = ctrls[name];
				} else if (ctrls[name].$name == 'nettoMaradvanyertek') {
					modelCtrl = ctrls[name];
				}
			}

			scope.$watch('$ctrl.kalk.futamido', function () {	//futamidő változása esetén is validáljon
				modelCtrl.$validate();
			});

			modelCtrl.$validators.range = function (modelValue) {
				var valid = true;
				if ($.isNumeric(modelValue) && scope.$ctrl.kalk.futamido && formCtrl.futamido.$valid && typeof scope.$ctrl.kalk.nettoMaradvanyertek != 'undefined') {
					var futamido = scope.$ctrl.kalk.futamido;
					if ((futamido >= 0 && futamido <= 12 && modelValue > 50) ||
						(futamido >= 13 && futamido <= 24 && modelValue > 35) ||
						(futamido >= 25 && futamido <= 36 && modelValue > 25) ||
						(futamido >= 37 && futamido <= 48 && modelValue > 20) ||
						(futamido >= 49 && futamido <= 60 && modelValue > 15) ||
						(futamido >= 61 && futamido <= 72 && modelValue > 5)) {

						valid = false;
					}
				}
				return valid;
			};

		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/validators/nettomaradvanyertekvalidator.js